<template>
    <div :class="'social-media-group-popup' + (isEdit ? ' is-edit': '')">
        <div class="row" v-if="allActiveUsers.length">
            <div class="col-7">
                <div class="group-title" v-show="!hideTitle">
                    <h1 class="mb-0 exclude-outside-click edit-d-title project-title" v-show="!editTitle" @click="activateTitleField">{{ socialCampaignDetail.title }}</h1>
                    <textarea
                        ref="editTitleRef"
                        v-show="editTitle"
                        type="text"
                        placeholder="Social Media Campaign..."
                        class="form-control mb-3 title-field exclude-outside-click h1"
                        v-model="socialCampaignDetail.title"
                        v-click-outside="clickOutsideTitle"
                        @change="updateSocialCampaign()"
                    ></textarea>
                </div>
                <!-- <div class="group-id">Campaign ID: 2022091308</div> -->
                <div class="campaign-date">
                    <div class="start-date field-box">
                    	<div>
                        <span class="date-label">Start Date</span>
                        <span class="editable-campaign-date">
                        <div class="custom-field-outside-bg-mobile"></div>
                        <vuejs-datepicker
                            placeholder="No Date"
                            v-model="socialCampaignDetail.start_date"
                            ref="startDatePicker"
                            @input="updateSocialCampaign()"
                        >
                            <div slot="beforeCalendarHeader" class="calender-header">
                            <b-button class="remove-dl-btn" variant="text" @click="onRemoveDate('startDate')">Remove Date</b-button>
                            <b-button class="today-btn" variant="text" @click="onToday('startDate')">Today</b-button>
                            </div>
                        </vuejs-datepicker>
                        </span>
                    </div>
                    </div>
                    <div class="end-date field-box">
                    	<div>
                        <span class="date-label">End Date </span>
                        <span class="editable-campaign-date">
                        <div class="custom-field-outside-bg-mobile"></div>
                        <vuejs-datepicker
                            placeholder="No Date"
                            v-model="socialCampaignDetail.end_date"
                            ref="endDatePicker"
                            @input="updateSocialCampaign()"
                        >
                            <div slot="beforeCalendarHeader" class="calender-header">
                            <b-button class="remove-dl-btn" variant="text" @click="onRemoveDate('endDate')">Remove Date</b-button>
                            <b-button class="today-btn" variant="text" @click="onToday('endDate')">Today</b-button>
                            </div>
                        </vuejs-datepicker>
                        </span>
                    </div>
                    </div>
                </div>
                <div
                    class="field-box social-campaign-detail-field"
                    v-for="(field, index) in _.filter(socialCampaignDetail.customFields, {field_key: 'social_campaign_detail'})"
                >
                    <CustomFields :key="'scfields'+socialCampaignDetail.id" :detail="socialCampaignDetail" :customField="field" :showLabel="false"/>
                </div>

                <!--
                <div class="group-resources">
                    <div class="resource-title">
                        <button class="resource-label exclude-outside-click d-inline-block" data-toggle="dropdown" aria-expanded="false">Resources<plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button></button>
                        <div class="dropdown-menu resources--type--menu">
                            <a class="dropdown-item" href="#" v-for="(type,i) in optionsForLinkType" :key="i" @click="addResourceMenuItemClick(type.id, $event)"><img class="link-type-icon" :src="require(`@/csmworkflow/img/${type.icon}`)"> {{type.name}}</a>
                        </div>
                    </div>
                    <div class="resource-content">
                        <div class="resource-entry"
                            :class="userCanEditSocialCampaign ? 'editable' : 'not-editable'"
                            v-for="(resource, index) in _.filter(socialCampaignDetail.customFields, {field_key: 'link_url'})"
                            :key="'link_url-'+index"
                            v-if="showResourceBox(resource.value,resource.scfv_id)"
                        >
                            <div class="resource-box__url"></div>
                            <a :href="resource.value" @click="openCopyLinkModal(resource.value, $event, index)" target="blank" :id="`social-campaign-resource-${index}`">{{customChildFieldValue('link_label',resource.scfv_id) || resource.value}}</a>
                            <b-tooltip :target="`social-campaign-resource-${index}`" noninteractive triggers="manual"><i class="fas fa-check" style="color:#4C9850;"></i> Link Copied!</b-tooltip>
                            <a
                            v-b-tooltip.hover
                            title="Edit resource"
                            class="edit-resource-btn"
                            href="#"
                            v-if="userCanEditSocialCampaign"
                            @click.prevent="editResource(resource)"
                            >
                            <i class="fas fa-edit"></i>
                            </a>
                            <img class="link-type-icon" :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type',resource.scfv_id)).icon}`)" draggable="false">
                            <div class="resource-box__notes" v-if="customChildFieldValue('link_notes',resource.scfv_id)">{{customChildFieldValue('link_notes',resource.scfv_id)}}</div>
                        </div>
                    </div>
                </div>
                -->
                <!-- <div class="create-button-area">
                    <button class="btn btn-secondary" @click="close">Close</button>
                    <button class="btn btn-primary" @click="createCampaign">Create</button>
                </div> -->
            </div>
            <div class="col-5 campaign-details">
                <div
                    class="field-box"
                    v-if="typeof socialCampaignDetail == 'object'"
                >
                    <CustomFields :key="'scfields'+socialCampaignDetail.id" :detail="socialCampaignDetail" :customField="{field_key: 'engagement_manager',field_name: 'engagement_manager', label: 'Engagement Manager'}" />
                </div>
                <div
                    class="field-box"
                    v-if="typeof socialCampaignDetail == 'object'"
                >
                    <CustomFields :key="'scfields'+socialCampaignDetail.id" :detail="socialCampaignDetail" :customField="{field_key: 'project_lead',field_name: 'project_lead', label: 'Project Lead'}" />
                </div>
                <div class="field-box"
                    v-for="(field, index) in _.filter(socialCampaignDetail.customFields, function(o) {
                        // Hardcoded
                        return !([20, 21, 22, 33, 37].includes(o.field_id)) && o.field_key != 'social_campaign_detail' && o.field_key != 'social_campaign_coordinator';
                    })"
                    :key="'sc_field_'+Math.random()"
                >
                    <CustomFields :key="'scfields'+socialCampaignDetail.id" :detail="socialCampaignDetail" :customField="field" />
                </div>

                <div class="project--resources">
                    <div class="dropdown project--resources--title">
                        <button
                            title="Add resource"
                            class="add-resource-button exclude-outside-click d-inline-block"
                            id="add-resource-button"
                            data-toggle="dropdown" aria-expanded="false"
                        >Resources</button>
                        <plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button>
                        <div class="dropdown-menu project--resources--type--menu">
                            <a class="dropdown-item" href="#" v-for="(type,i) in optionsForLinkType" :key="i" @click="addResourceMenuItemClick(type.id, $event)"><img class="link-type-icon" :src="require(`@/csmworkflow/img/${type.icon}`)"> {{type.name}}</a>
                        </div>
                    </div>
                    <div class="project--resources--content">
                        <div class="resource-entry"
                            :class="userCanEditSocialCampaign ? 'editable' : 'not-editable'"
                            v-for="(resource, index) in _.filter(socialCampaignDetail.customFields, {field_key: 'link_url'})"
                            :key="'link_url-'+index"
                            v-if="showResourceBox(resource.value,resource.scfv_id)"
                        >
                            <!-- <div class="resource-box__url" @click="setCookieForDownload()"></div> -->
                            <div class="resource-box__url">
                                <a :href="resource.value" @click="openCopyLinkModal(resource.value, $event, index)" target="blank" :id="`social-campaign-resource-${index}`">{{customChildFieldValue('link_label',resource.scfv_id) || resource.value}}</a>
                                <b-tooltip :target="`social-campaign-resource-${index}`" noninteractive triggers="manual"><i class="fas fa-check" style="color:#4C9850;"></i> Link Copied!</b-tooltip>
                            </div>
                            <a
                            v-b-tooltip.hover
                            title="Edit resource"
                            class="edit-resource-btn"
                            href="#"
                            v-if="userCanEditSocialCampaign"
                            @click.prevent="editResource(resource)"
                            >
                            <i class="fas fa-edit"></i>
                            </a>
                            <img class="link-type-icon" :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type',resource.scfv_id)).icon}`)" draggable="false">
                            <div class="resource-box__notes" v-if="customChildFieldValue('link_notes',resource.scfv_id)">{{customChildFieldValue('link_notes',resource.scfv_id)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Resources modal -->
        <b-modal centered  hide-footer id="createSocialCampaignLinkModal" title="New Resource / Link" @shown="focusLinkModal">
        <CreateLinkModal  ref="refLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" />
        </b-modal>
        <b-modal hide-footer id="editLinkModal" title="Update Resource / Link" @shown="focusEditLinkModal">
        <EditLinkModal  ref="refEditLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" v-bind:is-file="editLinkIsFile" />
        </b-modal>
        <b-modal centered id="linkCopyLinkModal" title="Copy Link" ok-only ok-title="Done">
        <LinkCopyLinkModal :linkUrl="linkCopyModalValue" />
        </b-modal>


        <div class="responsive-edit-modal-controls">
          <button
          v-b-tooltip.hover
          :title="'Delete Campaign: ' + socialCampaignDetail.title"
          @click="removeSocialCampaign()"
          class="btn delete-deliverable-btn"
          v-if="userAbilities.deleteSocialCampaign && !socialCampaignDetail.permissions.viewOnly && !hideDelete"
          >
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
        <b-modal v-model="showRemoveSocialCampaign" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveSocialCampaign" ok-title="Yes, Delete">
          <p>Are you sure you want to delete this social campaign?</p>
        </b-modal>

    </div>


</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions, mapGetters } from "vuex";
import CreateLinkModal from "./CreateSocialCampaignLinkModal";
import EditLinkModal from "./EditSocialCampaignLinkModal";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";
import CustomFields from './SocialCampaignCustomFields.vue';


export default {
    props: ['isEdit','hideTitle', 'hideDelete'],
    components: {
        'vuejs-datepicker': Datepicker,
        CreateLinkModal,
        EditLinkModal,
        LinkCopyLinkModal,
        CustomFields
    },
    data() {
        const loggedInUser = {id: localStorage.getItem("userId"), name: localStorage.getItem("user")};
        return {
            editTitle: false,
            emEditing: false,
            plEditing: false,
            budgetEditing: false,
            requisitionNumberEditing: false,
            socialCampaign: {
                title: "Social Media Campaign",
                start_date: this.$moment().format(),
                end_date: null,
                engagement_manager: loggedInUser,
                project_lead: loggedInUser,
                budget: null,
                requisitionNumber: "",
            },
            showRemoveSocialCampaign: false,
            // Resources
            linkUrl: null,
            linkLabel: null,
            linkNotes: null,
            linkType: null,
            editLinkIsFile: false,
            linkCopyModalValue: "",
        };
    },
    computed: {
        ...mapGetters([
            'allActiveUsers',
            'allCustomFields',
            'socialCampaignDetail',
            "userAbilities",
        ]),
        optionsForLinkType() {
            let linkTypeField = this.allCustomFields.find(x => x.id == 37);
            if (!linkTypeField) {
                this.$store.dispatch("fetchAllCustomFields");
            } else {
                return JSON.parse(linkTypeField.value_set);
            }
		},
        _() {
            return _;
        },
        userCanEditSocialCampaign() {
			const userId = localStorage.getItem("userId");
            const socialCampaign = this.socialCampaignDetail;

            if (this.userAbilities.accessAllSocialCampaigns) {
                return this.userAbilities.editSocialCampaign;
            }

            let isManager = false;
            if (socialCampaign.engagement_manager instanceof Object) {
                isManager = userId == socialCampaign.engagement_manager.id;
            } else {
                isManager = userId == socialCampaign.engagement_manager;
            }

            return (this.userAbilities.editSocialCampaign && isManager);
        },
    },
    methods: {
        ...mapActions([
            'createSocialCampaign',
            'updateSocialCampaignFieldValue',
        ]),
        activateTitleField() {
            this.editTitle = true;
            let that = this;
            setTimeout(() => {
                that.$refs.editTitleRef.select();
            }, 100);
        },
        clickOutsideTitle() {
            this.editTitle = false;
        },

        showEngagementManager() {
            this.emEditing = true;
            this.$nextTick(() => {
                this.$refs.emSelect.$el.focus();
            })
        },
        showProjectLead() {
            this.plEditing =  true;
            this.$nextTick(() => {
                this.$refs.plSelect.$el.focus();
            })
        },
        changeEngagementManager(v1, v2) {
            
        },
        changeProjectLead() {

        },

        clickOutsideEM() {
            this.emEditing = false;
        },
        clickOutsidePL() {
            this.plEditing = false;
        },

        onToday(dateType) {
            if (dateType == "startDate") {
                this.socialCampaign.start_date = this.$moment().format();
                this.$refs.startDatePicker.close();
            }
            else if (dateType == "endDate") {
                this.socialCampaign.end_date = this.$moment().format();
                this.$refs.endDatePicker.close();
            }
        },
        onRemoveDate(dateType) {
            if (dateType == "startDate") {
                this.socialCampaign.start_date = null;
                this.$refs.startDatePicker.close();
            }
            else if (dateType == "endDate") {
                this.socialCampaign.end_date = null;
                this.$refs.endDatePicker.close();
            }
        },

        createCampaign() {
            this.socialCampaign.engagement_manager = this.socialCampaign.engagement_manager.id;
            this.socialCampaign.project_lead = this.socialCampaign.project_lead.id;

            this.createSocialCampaign(this.socialCampaign);

            this.$emit("socialCampaignCreated", this.socialCampaign);
        },

        close() {
            this.$emit("socialCampaignClose");
        },


        budgetClick() {
            this.budgetEditing = true;
            setTimeout(() => {
                this.$refs.budgetInput.select();
            }, 100);
        },
        budgetClickOutside() {
            this.budgetEditing = false;
        },

        requisitionNumberClick() {
            this.requisitionNumberEditing = true;
            setTimeout(() => {
                this.$refs.requisitionNumberInput.select();
            }, 100);
        },
        requisitionNumberClickOutside() {
            this.requisitionNumberEditing = false;
        },

        showResourceBox(url, parent_id) {
            let fileId = this.customChildFieldValue('file_id',parent_id);
            return (url != null || fileId != null);
        },
        customChildField(key, parent_id) {
            if (this.socialCampaignDetail.customFields) {
                let obj = _.filter(this.socialCampaignDetail.customFields, {field_key: key, parent_id:parent_id});
                if (obj.length > 0) {
                    // lets add it to the
                    return obj;
                } else {
                    if (key == 'file_id') return null;
                    if (key == 'link_type') return [];
                    // return the global version of the custom field...
                    // let obj = _.filter(this.allCustomFields, {field_key: key});
                    let field = _.filter(this.allCustomFields, {field_key: key});
                    obj = {};
                    obj.id = null;
                    obj.parent_id = this.socialCampaignDetail.customFields[index].id;
                    obj.social_campaign_id = this.socialCampaignDetail.customFields[index].social_campaign_id;
                    obj.editing = false;
                    obj.field_id = field[0].id;
                    obj.field_key = field[0].field_key;
                    obj.field_parent_id = field[0].parent_id;
                    obj.field_type = field[0].field_type;
                    obj.note = field[0].note;
                    obj.value = null;
                    obj.label = field[0].label;
                    obj.value_set = field[0].value_set;
                    obj.updated_at = this.socialCampaignDetail.customFields[index].updated_at;
                    return [obj];
                }
            }
            return [];
        },
        customChildFieldValue(key, parent_id) {
            if (this.socialCampaignDetail.customFields) {
                let obj = _.filter(this.socialCampaignDetail.customFields, {field_key: key, parent_id:parent_id});
                if (obj.length > 0) {
                return obj[0].value;
                } else {
                return null;
                }
            }
            return null;
        },

        // Resources
        addResourceMenuItemClick(typeId, e) {
            e.preventDefault();
            this.addResource(typeId);
        },
        editResource(resource) {
            this.linkUrl = resource;
            let label =  this.customChildField('link_label', resource.scfv_id);
            if (label.length > 0) {
                this.linkLabel = label[0];
            } else {
                this.linkLabel = {};
            }
            let notes =  this.customChildField('link_notes', resource.scfv_id);
            if (notes.length > 0) {
                this.linkNotes = notes[0];
            } else {
                this.linkNotes = {};
            }
            let type = this.customChildField('link_type', resource.scfv_id);
            if (type.length > 0) {
                this.linkType = type[0];
            } else {
                this.linkType = {
                id:null,
                field_id:37,
                social_campaign_field_id: _.filter(this.socialCampaignDetail.customFields, {field_key: 'link_type'})[0]?.socialCampaignFieldId,
                parent_field_id: 20,
                field_key: "link_type",
                field_type: "select",
                parent_id: null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:1
                };
            }
            let fileId = this.customChildField('file_id', resource.scfv_id);
            this.editLinkIsFile = Boolean(fileId);
            this.$bvModal.show("editLinkModal");
        },
        addResource(typeId = 1) {
            this.linkUrl = {
                id:null,
                field_id:20,
                social_campaign_field_id:_.filter(this.socialCampaignDetail.customFields, {field_key: 'link_url'})[0].socialCampaignFieldId,
                parent_field_id:null,
                field_key:"link_url",
                field_type:"text",
                parent_id:null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:null
            };
            this.linkLabel = {
                id:null,
                field_id:21,
                social_campaign_field_id:_.filter(this.socialCampaignDetail.customFields, {field_key: 'link_label'})[0].socialCampaignFieldId,
                parent_field_id:20,
                field_key:"link_label",
                field_type:"text",
                parent_id:null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:null
            };
            this.linkNotes = {
                id:null,
                field_id:22,
                social_campaign_field_id:_.filter(this.socialCampaignDetail.customFields, {field_key: 'link_notes'})[0].socialCampaignFieldId,
                parent_field_id:20,
                field_key:"link_notes",
                field_type:"text",
                parent_id:null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:null
            };
            this.linkType = {
                id:null,
                field_id:37,
                social_campaign_field_id:_.filter(this.socialCampaignDetail.customFields, {field_key: 'link_type'})[0].socialCampaignFieldId,
                parent_field_id:20,
                field_key:"link_type",
                field_type:"select",
                parent_id:null,
                social_campaign_id: this.socialCampaignDetail.id,
                value:typeId
            };
            this.$bvModal.show("createSocialCampaignLinkModal");
        },
        focusLinkModal() {
            this.$refs.refLinkModal.focusMyElement();
        },
        focusEditLinkModal() {
            this.$refs.refEditLinkModal.focusMyElement();
        },
        removeSocialCampaign() {
          this.showRemoveSocialCampaign = true;
        },

        onConfirmRemoveSocialCampaign() {
          if (this.socialCampaignDetail.id) {
            let that = this;
            let socialCampaignId = this.socialCampaignDetail.id;
            let socialCampaignTemplateId = this.socialCampaignDetail.socialCampaign_template_id;
            this.$store.dispatch("removeSocialCampaign", { socialCampaignId:this.socialCampaignDetail.id }).then(function() {
              that.$bvModal.hide("editSocialCampaignModal");
              // TODO: removing a socialCampaign should only remove it from the list, not replace entire list.

              that.$store.dispatch('fetchSocialCampaigns').then(function() {
                // toast.hide();

                // if (socialCampaignTemplateId == 1) {
                // 	that.$store.dispatch('manageUndoActivation', 'Media call deleted.');
                // } else {
                // }
                that.$store.dispatch('manageUndoActivation', 'SocialCampaign deleted.');

              	// that.$store.dispatch('fetchProjectSocialCampaign');
              });
            });
          }
        },

        updateSocialCampaign() {
            this.$store.dispatch("updateSocialCampaign", this.socialCampaignDetail);
        },

        getLinkTypeObject(id) {
            if (id == null) id = 1;
            const r = this.optionsForLinkType.find(x => x.id == id);
            return r;
        },

        openCopyLinkModal(link, e, i) {
            if (!link.includes("\\")) {
                return;
            }
            e.preventDefault();
            this.copyLink(link, i);
        },
        async copyLink(link, resourceId) {
            clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
            Object.keys(this._.filter(this.socialCampaignDetail.customFields, {field_key: 'link_url'})).forEach(x => {
                if (x == resourceId) return;
                this.$root.$emit('bv::hide::tooltip', 'social-campaign-resource-' + x);
            })

            const navPer = await navigator.permissions.query({name: "clipboard-write"});
            if (navPer.state == "granted" || navPer.state == "prompt") {
                try {
                    await navigator.clipboard.writeText(link);
                } catch {
                    console.error("clipboard API error. Cannot copy to clipboard.");
                    this.legacyCopyMethod(link);
                }
            } else {
                this.legacyCopyMethod(link);
            }

            this.$root.$emit('bv::show::tooltip', 'social-campaign-resource-' + resourceId);
            this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
                this.$root.$emit('bv::hide::tooltip', 'social-campaign-resource-' + resourceId);
            }, 2000);
        },
    },
    mounted() {
        //console.log(this.socialCampaignDetail);
    },
}
</script>
<style scoped>
.campaign-details {
	padding-top:0px;
}
.type-label {
	font-weight:600;
	text-transform:uppercase;
	}
</style>